import * as yup from "yup";

import { DeliverKind } from "~/src/__generated__/schema";

type DeliverWeight = {
  readonly id: string;
  readonly name: string;
  readonly weight: number;
};

export type FormValues = {
  readonly deliverKind: DeliverKind;
  readonly deliverWeights: readonly DeliverWeight[];
};

export const DEFAULT_PATTERN_NAME = "デフォルト";

const deliverWeightSchema = yup.object({
  id: yup.string().required(),
  name: yup.string().required(),
  weight: yup
    .number()
    .test(
      "min-weight",
      "配信比率は1以上の数値を入力してください（デフォルトパターンのみ0が可能）",
      function (value) {
        if (value === undefined || value === null) return false;
        const { name } = this.parent;
        // Allow 0 only for default patterns, otherwise require minimum 1
        if (name === DEFAULT_PATTERN_NAME) {
          return value >= 0;
        }
        return value >= 1;
      }
    ),
});

export const validationSchema = yup.object({
  deliverKind: yup.string().required(),
  deliverWeights: yup.array().of(deliverWeightSchema),
});
